// extracted by mini-css-extract-plugin
module.exports = {"actionButtonsContainer":"ReferralSources_actionButtonsContainer__1wGK6","actionColumn":"ReferralSources_actionColumn__1Wm5K","textButton":"ReferralSources_textButton__2G2KZ"};